// extracted by mini-css-extract-plugin
export default {"Steps5":"Steps5___mjgFI","ProgressBarBg":"ProgressBarBg___bWa2Y","ProgressBar":"ProgressBar___lgKPE","ProgressCircle":"ProgressCircle___z5DT2","red":"red___d4Nln"};